import keyMirror from 'keymirror';

export default keyMirror({
  RECIEVE_CODES: null,
  RECIEVE_CODES_ERROR: null
});



// WEBPACK FOOTER //
// ./src/constants/CodeConstants.js